// Images
require.context("../images", true)

// CSS
import "stylesheets/decidim/system/application.scss"
